import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Locale from '../locales/en/communityEquityAndJustice';
import Goals from './Goals';

const CommunityEquityAndJustice = ({ setGoalsView }) => {
  const [dataVisibility, setDataVisibility] = useState(false);
  const datapoint = useRef(null);

  const findDataVisibility = () => {
    if (!datapoint && !datapoint.current) {
      setDataVisibility(false);
      return;
    }
    const rect = datapoint.current.getBoundingClientRect();
    const bool = !(rect.y > window.innerHeight || rect.y < (rect.height * -1));
    setDataVisibility(bool);
  };

  useEffect(() => {
    window.addEventListener('scroll', findDataVisibility);

    return () => window.removeEventListener('scroll', findDataVisibility);
  }, []);

  const dataSVG = (
    <svg
      className={`bar-graph ${dataVisibility ? 'animate' : ''}`}
      viewBox="0 0 548 411"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      ref={datapoint}
    >
      <title>Wealth gap graph</title>
      <g id="Page-1" stroke="none" fill="none">
        <g id="Home-after-load---social-share" transform="translate(-151.000000, -2745.000000)">
          <g id="Group-44" transform="translate(151.000000, 2745.500000)">
            <text id="White" fontSize="20" fontWeight="300" fill="#FFFFFF">
              <tspan x="59.58" y="408.26">White</tspan>
            </text>
            <text id="$100,000" fontSize="15" fontWeight="300" fill="#FFFFFF">
              <tspan x="483.15" y="40.5">$100,000</tspan>
            </text>
            <text id="$50,000" fontSize="15" fontWeight="300" fill="#FFFFFF">
              <tspan x="489.705" y="217.5">$50,000</tspan>
            </text>
            <text id="Black" fontSize="20" fontWeight="300" fill="#FFFFFF">
              <tspan x="263.11" y="408.26">Black</tspan>
            </text>
            <text id="Latinx" fontSize="20" fontWeight="300" fill="#FFFFFF">
              <tspan x="440" y="408.26">Latinx</tspan>
            </text>
            <g id="Group-43" transform="translate(197.333769, 231.000000)">
              <rect
                id="black-wealth"
                fill="#0D63A3"
                x="15"
                y="200"
                width="23%"
                height="35%"
              />
              <polygon id="Fill-4" fill="#9EC1E2" points="0 145.026667 125.335076 145.026667 125.335076 122.445122 0 122.445122" />
            </g>
            <g id="Group-42" transform="translate(388.000000, 248.216320)">
              <g id="Group-27" transform="translate(16.000000, 0.000000)" fill="#0D63A3">
                <rect
                  id="latinx-wealth"
                  fill="#0D63A3"
                  x="0"
                  y="200"
                  width="23%"
                  height="31%"
                />
              </g>
              <polygon id="Fill-4" fill="#9EC1E2" points="0 127.810347 125.335076 127.810347 125.335076 101.12544 0 101.12544" />
            </g>
            <polygon id="Fill-7" fill="#9EC1E2" points="23.3324621 376 148.667538 376 148.667538 0 23.3324621 0" />
            <path d="M0.5,17.5 L547.5,17.5" id="Line" stroke="#DCE8F5" strokeWidth="0.5" strokeLinecap="square" />
            <path d="M0.5,196.5 L547.5,196.5" id="Line-Copy" stroke="#DCE8F5" strokeWidth="0.5" strokeLinecap="square" />
            <path d="M0.5,375.5 L547.5,375.5" id="Line-Copy-2" stroke="#DCE8F5" strokeWidth="0.5" strokeLinecap="square" />
          </g>
        </g>
      </g>
    </svg>
  );

  return (
    <div id="community-equity-and-justice">
      <div className="bg-wrapper-vision">
        <div className="vision">
          <h1>
            {Locale.title}
          </h1>
          <div className="text-box">
            {Locale.visionTitle}
          </div>
          <h3>
            {Locale.visionSubHeader}
          </h3>
          <div
            className="vision-body"
            dangerouslySetInnerHTML={{ __html: Locale.visionBody }}
          />
        </div>
      </div>
      <div className="bg-wrapper-visual-datapoint">
        <div className="visual-datapoint">
          <div className="visual">
            <div className="data-intro">{Locale.datapoint.intro}</div>
            {dataSVG}
            <div className="legend">
              <div className="legend-key">
                <div className="current" />
                <div className="legend-text">{Locale.datapoint.legend.current}</div>
              </div>
              <div className="legend-key">
                <div className="possible" />
                <div className="legend-text">{Locale.datapoint.legend.possible}</div>
              </div>
            </div>
          </div>
          <div
            className="data"
            dangerouslySetInnerHTML={{ __html: Locale.datapoint.description }}
          />
        </div>
      </div>
      <Goals
        items={Locale.goals}
        setGoalsView={setGoalsView}
      />
    </div>
  );
};

CommunityEquityAndJustice.propTypes = {
  setGoalsView: PropTypes.func.isRequired
};

export default CommunityEquityAndJustice;
